import { useSEO } from "../../hooks/useSEO";

const TermsOfService = () => {
  useSEO({
    title: "Terms of Service",
    description: "TaxShift 2026 Terms of Service governing use of our calculators and content.",
    path: "/terms-of-service",
  });

  return (
    <div className="py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="font-mono uppercase text-[10px] tracking-[0.3em] text-muted-foreground mb-4 block">
          Compliance · Terms
        </span>
        <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight mb-3" data-testid="terms-title">
          Terms of Service
        </h1>
        <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-10 pb-6 border-b-2 border-foreground">
          Last updated: February 2026
        </p>
        <div className="font-body text-base leading-relaxed space-y-5 text-foreground/85">
          <p>
            By accessing or using TaxShift 2026 (the "Service"), you agree to these Terms of
            Service. If you do not agree, do not use the Service.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">1. Use of the Service</h2>
          <p>
            We grant you a personal, non-exclusive, non-transferable license to access and use the
            Service for personal, non-commercial purposes. You agree not to (a) reverse engineer,
            scrape systematically, or exploit the Service for commercial redistribution; (b)
            interfere with the operation of the Service; (c) misrepresent your affiliation with
            us.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">2. Not tax or financial advice</h2>
          <p>
            The calculators, articles, and other content are provided for educational and
            illustrative purposes only. They do not constitute tax advice, legal advice, accounting
            advice, or financial advice. Always consult a qualified professional before making any
            decision based on information provided by the Service. See our{" "}
            <a href="/disclaimer" className="underline text-primary">full Disclaimer</a>.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">3. Intellectual property</h2>
          <p>
            All content — text, calculators, graphics, logos, code — is owned by TaxShift 2026 or
            licensed to us. You may not reproduce, distribute, or create derivative works without
            prior written permission, except for personal, non-commercial sharing with attribution.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">4. User content</h2>
          <p>
            If you submit content (e.g., contact messages, newsletter emails), you grant us a
            worldwide, royalty-free license to use it for Service operations. You represent that
            you own or have rights to such content.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">5. Advertising</h2>
          <p>
            The Service displays advertising served by Google AdSense and potentially other
            providers. Advertisers and their content are not endorsed by TaxShift 2026.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">6. Warranty disclaimer</h2>
          <p>
            THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND,
            EXPRESS OR IMPLIED, INCLUDING FITNESS FOR A PARTICULAR PURPOSE, ACCURACY,
            NON-INFRINGEMENT, OR UNINTERRUPTED OPERATION.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">7. Limitation of liability</h2>
          <p>
            TO THE FULLEST EXTENT PERMITTED BY LAW, TAXSHIFT 2026 IS NOT LIABLE FOR INDIRECT,
            INCIDENTAL, CONSEQUENTIAL, SPECIAL, OR PUNITIVE DAMAGES, OR LOST PROFITS OR REVENUES,
            ARISING FROM YOUR USE OF THE SERVICE, EVEN IF ADVISED OF THE POSSIBILITY.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">8. Indemnification</h2>
          <p>
            You agree to indemnify and hold us harmless from claims arising from your misuse of the
            Service or violation of these Terms.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">9. Changes</h2>
          <p>
            We may modify these Terms at any time. Continued use after changes constitutes
            acceptance.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">10. Governing law</h2>
          <p>
            These Terms are governed by the laws of the State of Delaware, USA, excluding conflicts
            of law principles. Disputes shall be resolved exclusively in the state or federal
            courts located in Delaware.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">11. Contact</h2>
          <p>
            Questions: <strong>legal@taxshift2026.com</strong>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
